<script setup lang="ts">
import FlexComponent from './FlexComponent/FlexComponent.vue'
import LoadingIcon from '@/assets/icons/loading.svg?component'

withDefaults(defineProps<{ size?: number; isFullSize?: boolean }>(), { size: 24, isFullSize: false })
</script>

<template>
  <FlexComponent :class="['container', { full: isFullSize }]" align="center" justify="space-around">
    <el-icon :size="size">
      <LoadingIcon />
    </el-icon>
  </FlexComponent>
</template>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;

  &.full {
    height: calc(100vh - 72px);
  }
}
</style>
